import { Button, InputLabel, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import TagListComponent from './TagListComponent';

export default function AddTags() {
    const {
        addNewTag,
        tagTitleToAdd,
        setTagTitleToAdd,
        tagsLoading,
        fetchTags,
        tags,
    } = useTagsHook();

    useEffect(() => {
        fetchTags();
    }, [])

    return (
        <div className='flex justify-start items-center flex-col min-h-screen bg-gray-50 py-8'>
            <h1 className='text-3xl font-bold my-8 text-gray-800'>
                Add New Tag
            </h1>
            <div className='bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4'>
                <InputLabel
                    style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: 'black',
                        marginBottom: '16px'
                    }}>
                    Tag Name
                </InputLabel>
                <TextField
                    label='Tag Name'
                    variant='outlined'
                    fullWidth
                    style={{ marginBottom: '24px' }}
                    type="text"
                    placeholder='Enter tag name'
                    value={tagTitleToAdd}
                    onChange={(e) => setTagTitleToAdd(e.target.value)}
                />
                {
                    tagsLoading === true
                        ? <Button
                            onClick={() => { }}
                            disabled
                            fullWidth
                            style={{ marginBottom: '16px' }}
                            variant='contained'
                            color='primary'>
                            Adding...
                        </Button>
                        : <Button
                            onClick={addNewTag}
                            disabled={tagTitleToAdd.trim() === ''}
                            fullWidth
                            style={{ marginBottom: '16px' }}
                            variant='contained'
                            color='primary'>
                            Add Tag
                        </Button>
                }
            </div>

            {/* Show existing tags */}
            {tags && tags.data && tags.data.length > 0 && (
                <div className='mt-12 w-full max-w-6xl px-4'>
                    <h2 className='text-2xl font-bold text-center mb-8 text-gray-700'>
                        Existing Tags
                    </h2>
                    <div className='flex justify-center items-center flex-wrap gap-4'>
                        {tags.data.map((tag: any, index: number) => {
                            return (
                                <TagListComponent
                                    key={index}
                                    tag={tag}
                                    tagIndex={index}
                                    type='LIST'
                                />
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}
